import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["emailForm", "emailButton", "emailHint"]

  connect() {
    if (this.hasEmailFormTarget && !this.emailFormTarget.dataset.open) this.hideEmailForm()
  }

  showEmail() {
    this.emailFormTarget.classList.remove("hidden")
    this.emailFormTarget.dataset.open = "true"
    this.emailButtonTarget.setAttribute("aria-expanded", "true")
    if (this.hasEmailHintTarget) this.emailHintTarget.classList.remove("hidden")
    this.emailFormTarget.querySelector("input")?.focus()
  }

  hideEmailForm() {
    this.emailFormTarget.classList.add("hidden")
    this.emailFormTarget.dataset.open = "false"
    this.emailButtonTarget.setAttribute("aria-expanded", "false")
    if (this.hasEmailHintTarget) this.emailHintTarget.classList.add("hidden")
  }
}
